import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import "../../styles/CallToAction.css";

interface CallToActionProps {
  title: string;
  ctaText: string;
  ctaLink?: string;
  requestServiceName?: string;
}

const getRequestAwareLink = (href: string, requestServiceName?: string) => {
  if (href !== "/contact" || !requestServiceName) {
    return href;
  }

  return `/contact?service=${encodeURIComponent(
    requestServiceName
  )}&source=solution-cta`;
};

const CallToAction: React.FC<CallToActionProps> = ({
  title,
  ctaText,
  ctaLink,
  requestServiceName,
}) => {
  const linkUrl = getRequestAwareLink(ctaLink || "/contact", requestServiceName);
  const isExternalLink = /^https?:\/\//i.test(linkUrl);
  const isAnchorLink = linkUrl.startsWith("#");
  const button = <button className="cta-button">{ctaText}</button>;

  return (
    <div className="call-to-action">
      <h2>{title}</h2>
      {isExternalLink || isAnchorLink ? (
        <a
          href={linkUrl}
          target={isExternalLink ? "_blank" : undefined}
          rel={isExternalLink ? "noopener noreferrer" : undefined}
        >
          {button}
        </a>
      ) : (
        <Link to={linkUrl}>{button}</Link>
      )}
    </div>
  );
};

export default CallToAction;
